import { api } from "../configs/apiConfig";

// Ticket Type Services
export const getTicketTypes = async () => {
  try {
    const response = await api.get("/Ticket/types/all");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch ticket types:", error.response?.data || error.message);
    throw error;
  }
};

export const getTicketTypeById = async (id) => {
  try {
    const response = await api.get(`/Ticket/types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch ticket type:", error.response?.data || error.message);
    throw error;
  }
};

export const createTicketType = async (ticketTypeData) => {
  try {
    const response = await api.post("/Ticket/types", ticketTypeData);
    return response.data;
  } catch (error) {
    console.error("Failed to create ticket type:", error.response?.data || error.message);
    throw error;
  }
};

export const updateTicketType = async (id, ticketTypeData) => {
  try {
    const response = await api.put(`/Ticket/types/${id}`, ticketTypeData);
    return response.data;
  } catch (error) {
    console.error("Failed to update ticket type:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteTicketType = async (id) => {
  try {
    await api.delete(`/Ticket/types/${id}`);
    return true;
  } catch (error) {
    console.error("Failed to delete ticket type:", error.response?.data || error.message);
    throw error;
  }
};

// Ticket Services
export const getAllTickets = async () => {
  try {
    const response = await api.get("/Ticket");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch tickets:", error.response?.data || error.message);
    throw error;
  }
};

export const getUserTickets = async (userId) => {
  try {
    const response = await api.get(`/Ticket/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user tickets:", error.response?.data || error.message);
    throw error;
  }
};

export const getTicketById = async (id) => {
  try {
    const response = await api.get(`/Ticket/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch ticket:", error.response?.data || error.message);
    throw error;
  }
};

export const createTicket = async (userId, ticketData) => {
  try {
    const response = await api.post(`/Ticket/${userId}`, ticketData);
    return response.data;
  } catch (error) {
    console.error("Failed to create ticket:", error.response?.data || error.message);
    throw error;
  }
};

export const updateTicket = async (id, ticketData) => {
  try {
    const response = await api.put(`/Ticket/${id}`, ticketData);
    return response.data;
  } catch (error) {
    console.error("Failed to update ticket:", error.response?.data || error.message);
    throw error;
  }
};

export const processTicket = async (id, ticketData) => {
  try {
    const response = await api.post(`/Ticket/${id}/process`, ticketData);
    return response.data;
  } catch (error) {
    console.error("Failed to process ticket:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteTicket = async (id) => {
  try {
    await api.delete(`/Ticket/${id}`);
    return true;
  } catch (error) {
    console.error("Failed to delete ticket:", error.response?.data || error.message);
    throw error;
  }
};

const ticketService = {
  // Ticket Types
  getTicketTypes,
  getTicketTypeById,
  createTicketType,
  updateTicketType,
  deleteTicketType,

  // Tickets
  getAllTickets,
  getUserTickets,
  getTicketById,
  createTicket,
  updateTicket,
  processTicket,
  deleteTicket
};

export default ticketService;
